import React from 'react';
import Header from './Header';
import Footer from './Footer';

/** Khung chung cho các trang công khai (trang chủ, trang giới thiệu ứng dụng). */
const PublicLayout = ({ children, showFooter = true }) => (
    <div className="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950 transition-colors duration-300">
        <Header />
        <main className="flex-1 relative z-10 pt-16 md:pt-20">{children}</main>
        {showFooter && <Footer />}
    </div>
);

export default PublicLayout;
